// extracted by mini-css-extract-plugin
module.exports =  {"tile":"beLFCEE","icon":"Pu6LyoW","title":"A3ckPv7"};